import { FilterLogic, SolutionState } from '../SOL49';

export interface MonitoringPeriodSettings {
    deltaDay: number;
    mode: TimeOptionEnum;
    fromMs: number; // ms
    toMs: number;
    beforeCurrentMn: number;
    afterCurrentMn: number;
}

export interface FilterSettings<Config> {
    filterLogic: FilterLogic;
    config: Config;
}

export type CoordinationStatusType = { [key: string]: { [key: string]: SolutionState } };

export enum EntityType {
    MEASURE_PROPOSAL,
    MEASURE,
    MONITORED_EVENT,
    COORDINATION,
}

export enum TimeOptionEnum {
    RELATIVE_TO_NOW,
    ABSOLUTE,
}
